export default "__VITE_ASSET__2ce994c1__"